import React from "react";
import DashboardShell from "../../dashboard/DashboardShell";
import Seo from "../../components/Seo";

const NAV = [
  { to: "/admin", label: "Overview", end: true, icon: "overview", primary: true },
  { to: "/admin/requests", label: "Requests", icon: "requests", primary: true },
  { to: "/admin/projects", label: "Projects", icon: "projects", primary: true },
  { to: "/admin/leads", label: "Leads", icon: "leads" },
  { to: "/admin/accounts", label: "Accounts", icon: "accounts", primary: true },
  { to: "/admin/case-studies", label: "Case studies", icon: "case" },
  // Controls the mobile app's Playground grid (config/appLayout in Firestore).
  { to: "/admin/layout", label: "Layout", icon: "layout" },
  { to: "/admin/products", label: "Products", icon: "products" },
  { to: "/admin/usage", label: "Usage", icon: "usage" },
  { to: "/admin/users", label: "Users", icon: "users" },
  { to: "/admin/blog", label: "Blog", icon: "blog" },
  { to: "/admin/messages", label: "Messages", icon: "messages", primary: true },
  { to: "/admin/notifications", label: "Notifications", icon: "notifications" },
  { to: "/admin/invoices", label: "Invoices", icon: "invoices" },
];

const AdminLayout = () => (
  <>
    {/* Belt and braces with the Disallow in robots.txt: the admin shell is
        behind auth, but a crawler that reaches the URL should never index it. */}
    <Seo title="Admin — bboy creative" path="/admin" noindex />
    <DashboardShell navItems={NAV} roleLabel="Admin" />
  </>
);

export default AdminLayout;
